export class ArrayUtil {
  /** Pure Fisher–Yates shuffle */
  static shuffleArray<T>(a: T[]): T[] {
    const array = [...a];
    let currentIndex = array.length,
      temporaryValue: T,
      randomIndex: number;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}
